import Pinner from './ethereumIpfsPinner2.js';
import Contract from '../contracts/ethereumContract.js';
import {web3} from '../web3.js';

var ethereumContract = new Contract();

class SamplesPinner {
    constructor() {
        console.log('constructing pinner');
        this.samplesPinner = new Pinner(
            ethereumContract,
            [web3.utils.sha3('SampleCreated(address,bytes32,string)'), null, null],
            2, // index of the ipfs index in topic
            false,
            true
        );
    }

    pinAll() {
        this.samplesPinner.pinAll();
    }

    getStats() {
        return this.samplesPinner.getStats();
    }
}

export default SamplesPinner;

